/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { UserNotificationV1 } from '../models/user-notification-v-1';


/**
 * User notifications panel API
 */
@Injectable({
  providedIn: 'root',
})
export class NotificationsV1Service extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation unarchiveUserNotificationV1
   */
  static readonly UnarchiveUserNotificationV1Path = '/v1/notifications/{notificationId}/unarchive';

  /**
   * Unarchive a notification.
   *
   * Moves the notification back to the New tab.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `unarchiveUserNotificationV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  unarchiveUserNotificationV1$Response(params: {
    notificationId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserNotificationV1>> {

    const rb = new RequestBuilder(this.rootUrl, NotificationsV1Service.UnarchiveUserNotificationV1Path, 'post');
    if (params) {
      rb.path('notificationId', params.notificationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserNotificationV1>;
      })
    );
  }

  /**
   * Unarchive a notification.
   *
   * Moves the notification back to the New tab.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `unarchiveUserNotificationV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  unarchiveUserNotificationV1(params: {
    notificationId: string;
  },
  context?: HttpContext

): Observable<UserNotificationV1> {

    return this.unarchiveUserNotificationV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserNotificationV1>) => r.body as UserNotificationV1)
    );
  }

  /**
   * Path part for operation markUserNotificationReadV1
   */
  static readonly MarkUserNotificationReadV1Path = '/v1/notifications/{notificationId}/read';

  /**
   * Mark a notification as read.
   *
   * Clears the unread indicator on the notification.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `markUserNotificationReadV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  markUserNotificationReadV1$Response(params: {
    notificationId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserNotificationV1>> {

    const rb = new RequestBuilder(this.rootUrl, NotificationsV1Service.MarkUserNotificationReadV1Path, 'post');
    if (params) {
      rb.path('notificationId', params.notificationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserNotificationV1>;
      })
    );
  }

  /**
   * Mark a notification as read.
   *
   * Clears the unread indicator on the notification.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `markUserNotificationReadV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  markUserNotificationReadV1(params: {
    notificationId: string;
  },
  context?: HttpContext

): Observable<UserNotificationV1> {

    return this.markUserNotificationReadV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserNotificationV1>) => r.body as UserNotificationV1)
    );
  }

  /**
   * Path part for operation archiveUserNotificationV1
   */
  static readonly ArchiveUserNotificationV1Path = '/v1/notifications/{notificationId}/archive';

  /**
   * Archive a notification.
   *
   * Moves the notification to the Archived tab. Only the owner can archive.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `archiveUserNotificationV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  archiveUserNotificationV1$Response(params: {
    notificationId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserNotificationV1>> {

    const rb = new RequestBuilder(this.rootUrl, NotificationsV1Service.ArchiveUserNotificationV1Path, 'post');
    if (params) {
      rb.path('notificationId', params.notificationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserNotificationV1>;
      })
    );
  }

  /**
   * Archive a notification.
   *
   * Moves the notification to the Archived tab. Only the owner can archive.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `archiveUserNotificationV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  archiveUserNotificationV1(params: {
    notificationId: string;
  },
  context?: HttpContext

): Observable<UserNotificationV1> {

    return this.archiveUserNotificationV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserNotificationV1>) => r.body as UserNotificationV1)
    );
  }

  /**
   * Path part for operation markAllUserNotificationsReadV1
   */
  static readonly MarkAllUserNotificationsReadV1Path = '/v1/notifications/read-all';

  /**
   * Mark all unread notifications as read.
   *
   * Clears unread indicators on all of the current user's notifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `markAllUserNotificationsReadV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  markAllUserNotificationsReadV1$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, NotificationsV1Service.MarkAllUserNotificationsReadV1Path, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Mark all unread notifications as read.
   *
   * Clears unread indicators on all of the current user's notifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `markAllUserNotificationsReadV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  markAllUserNotificationsReadV1(params?: {
  },
  context?: HttpContext

): Observable<void> {

    return this.markAllUserNotificationsReadV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation listUserNotificationsV1
   */
  static readonly ListUserNotificationsV1Path = '/v1/notifications';

  /**
   * List current user's notifications.
   *
   * Returns the authenticated user's notifications. Use archived=true to retrieve the Archived tab.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listUserNotificationsV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  listUserNotificationsV1$Response(params?: {
    archived?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserNotificationV1>> {

    const rb = new RequestBuilder(this.rootUrl, NotificationsV1Service.ListUserNotificationsV1Path, 'get');
    if (params) {
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserNotificationV1>;
      })
    );
  }

  /**
   * List current user's notifications.
   *
   * Returns the authenticated user's notifications. Use archived=true to retrieve the Archived tab.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listUserNotificationsV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listUserNotificationsV1(params?: {
    archived?: boolean;
  },
  context?: HttpContext

): Observable<UserNotificationV1> {

    return this.listUserNotificationsV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserNotificationV1>) => r.body as UserNotificationV1)
    );
  }

}
